import { useAdvanceSearchContext } from "../AdvanceSearchContextTest";

export default function PersonalCharacteristics({ searchObject, onChange, t }) {
  return (
    <div>
      <legend className="fontsize-legend">
        {t("Personal Characteristics")}
      </legend>
      <input
        PersonnalCharacteristics
        name="personnalCharacteristics"
        onChange={onChange}
        value={searchObject.personnalCharacteristics || ""}
        className="form-control fontsize-legend"
      />
    </div>
  );
}
